import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import Icon from '../../Icon/Icon'

import Reviewer from './Reviewer'

function FullReviewModal({
  modalIsOpen, closeModal, review, showStarsRating = true,
}) {
  return (
    <Modal
      isOpen={modalIsOpen}
      shouldCloseOnOverlayClick
      onRequestClose={closeModal}
      contentLabel="Modal"
      ariaHideApp={false}
      className={{
        base: '',
        afterOpen: 'overlay-modal--container_after-open overlay-modal-container--smaller',
        beforeClose: 'overlay-modal--container_before-close',
      }}
      overlayClassName={{
        base: 'overlay-modal--background',
        afterOpen: 'overlay-modal--background_after-open',
        beforeClose: 'overlay-modal--background_before-close',
      }}
    >
      <div className="overlay-modal">
        <button className="btn btn-transparent overlay-modal--close-inner" onClick={closeModal}>
          <Icon type={['fal', 'times']} color="grey-dark" />
        </button>
        <div className="overlay-modal--content overlay-modal--full-review full-review-modal">
          <div className="l-inner-large">
            <Reviewer
              name={review.name}
              rating={review.rating}
              avatar={review.avatar.large_url}
              showStarsRating={showStarsRating}
              createdAt={review.createdAt}
            />
            <h3 className="review__title">{review.title}</h3>
            <p className="review__content">
              {review.content}
            </p>
          </div>
        </div>
      </div>
    </Modal>
  )
}

FullReviewModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  review: PropTypes.shape({
    name: PropTypes.string.isRequired,
    rating: PropTypes.number.isRequired,
    avatar: PropTypes.object,
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
  }).isRequired,
  showStarsRating: PropTypes.bool,
}

export default FullReviewModal
